import { birthday2Age, birthday2AgeForConsultance } from "helper/common";
import { FIELD_TYPE } from "types/enums";
import { ColumnsEdit } from "types/models/column-table-edit";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT, DATE, CODE, COMBO_BOX } = FIELD_TYPE;

const dataField: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "maBenhNhan",
    placeholder: "Nhập",
  },
  {
    type: INPUT,
    label: "Tên bệnh nhân",
    name: "tenBenhNhan",
    placeholder: "Nhập",
  },
  {
    type: SELECT,
    label: "Đối tượng",
    name: "doiTuong",
    placeholder: "Chọn",
  },
  {
    type: SELECT,
    label: "Nguồn bệnh nhân",
    name: "nguonBn",
    placeholder: "Chọn",

    options: [
      // {value: 0, label: "Thanh toán"},
      // {value: 1, label: "Hoàn phí"},
      // {value: 2, label: "Huỷ thanh toán"},
    ],
  },

  {
    type: INPUT,
    label: "Bác sĩ chỉ định",
    name: "bsChiDinh",
    placeholder: "Nhập",

    // options: [
    //   {value: 0, label: "Tiền mặt"},
    //   {value: 1, label: "Chuyển khoản"},
    //   {value: 2, label: "Quẹt thẻ"},
    // ],
  },

  {
    type: INPUT,
    label: "Nhân viên tư vấn",
    name: "nvTuVan",
    placeholder: "Nhập",
    // options: [
    //   {value: 0, label: "Tiền mặt"},
    //   {value: 1, label: "Chuyển khoản"},
    //   {value: 2, label: "Quẹt thẻ"},
    // ],

    // onChange : onChangeSelect,
  },

  {
    type: DATE,
    label: "Thời gian phẫu thuật từ",
    name: "start",
    disableDate: false,
    // optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
  },
  {
    type: DATE,
    label: "Thời gian phẫu thuật đến",
    name: "end",
    disableDate: false,

    // optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
  },

  {
    type: SELECT,
    label: "Loại IOL sử dụng",
    name: "loaiIOLSuDung",
    placeholder: "chọn",
    // options: [
    //   {value: 0, label: "Tiền mặt"},
    //   {value: 1, label: "Chuyển khoản"},
    //   {value: 2, label: "Quẹt thẻ"},
    // ],
  },
];

const columnsTable: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: "40px",
    render: (text, record, index) => index + 1,
    align: "center",
  },
  {
    title: "Thời gian",
    dataIndex: "thoiGian",
    key: "thoiGian",
    // width: '100px',
    align: "center",
  },
  {
    title: "Mã bệnh nhân",
    dataIndex: "maBenhNhan",
    key: "idBenhNhan",
    // width: '100px',
    align: "center",
  },
  {
    title: "Mã phiếu khám",
    dataIndex: "idPhieuKham",
    key: "idPhieuKham",
    // width: '100px',
    align: "center",
  },
  {
    title: "Tên bệnh nhân",
    dataIndex: "tenBenhNhan",
    key: "tenBenhNhan",
    // width: '8%',
    align: "left",
  },
  {
    title: "Ngày sinh",
    dataIndex: "ngaySinh",
    key: "ngaySinh",
    // width: '100px',
    align: "center",
  },
  {
    title: "Tuổi",
    // dataIndex: "tuoi",
    key: "tuoi",
    // width: '8%',
    align: "center",
    render: (texr, r: any, i) => {
      // console.log("🚀 ~ v:", r);
      return r?.ngaySinh ? birthday2AgeForConsultance(r.ngaySinh) : "";
    },
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    key: "gioiTinh",
    // width: '100px',
    align: "left",
  },
  {
    title: "SĐT",
    dataIndex: "soDienThoai",
    key: "soDienThoai",
    // width: '8%',
    align: "center",
  },
  {
    title: "Địa chỉ",
    dataIndex: "diaChi",
    key: "diaChi",
    // width: '8%',
    align: "left",
  },
  {
    title: "Mức hưởng BHYT",
    dataIndex: "mucHuongBHYT",
    key: "mucHuongBHYT",
    // width: '100px',
    align: "center",
    render: (v) => (v ? v + "%" : ""),
  },
  {
    title: "Đối tượng",
    dataIndex: "doiTuong",
    key: "doiTuong",
    // width: '100px',
    align: "left",
  },
  // {
  //   title: "Cập nhật tình trạng",
  //   dataIndex: "capNhatTinhTrang",
  //   key: "doiTuong",
  //   width: 120,
  //   align: "left",
  // },
  {
    title: "Nguồn bệnh nhân",
    dataIndex: "nguonBenhNhan",
    key: "nguonBenhNhan",
    // width: '8%',
    align: "left",
    // render : (value, record, index) => {
    //   return <>{formatToCurrencyType(value)}</>
    // }
  },
  {
    title: "Bác sĩ chỉ định",
    dataIndex: "bsChiDinh",
    key: "bsChiDinh",
    // width: '100px',
    align: "left",
    // render : (value, record, index) => {
    //   return <>{formatToCurrencyType(value)}</>
    // }
  },
  {
    title: "Loại phẫu thuật",
    dataIndex: "loaiPhauThuat",
    key: "loaiPhauThuat",
    // width: '8%',
    align: "left",
  },
  {
    title: "Nhân viên tư vấn",
    dataIndex: "nvTuVan",
    key: "nvTuVan",
    // width: '100px',
    align: "left",
    // render : (value, record, index) => {
    //   return <>{formatToCurrencyType(value)}</>
    // }
  },
  {
    title: "Loại IOL sử dụng",
    dataIndex: "loaiIOL",
    key: "loaiIOL",
    // width: '8%',
    align: "left",
  },
];

export { dataField, columnsTable };
